import { useIsClient } from "@crehana/react-hooks";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var ClientSideComponent = function ClientSideComponent(_ref) {
  var children = _ref.children,
    fallback = _ref.fallback;
  var isClient = useIsClient();
  if (!isClient) {
    if (fallback) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: fallback
      });
    }
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default ClientSideComponent;